<template>
  <div class="modal fade1 in" id="modal-default" style="display: block;" :v-show="shwovalueEditPost">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-label="Close">
                <span aria-hidden="true" @click="closePost()">×</span></button>
                <h4>Edit ID</h4>
            </div>
            <div class="modal-body">
                <div class="card-body">
                    <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitProfile" novalidate>
                        <div class="col-md-12">
                            <input v-if="Boolean(editoption2)" type="submit" value="Save" style="width: 93px;height: 30px;" class="submit pull-right" name="submit" id="submit" />
                            <button v-if="Boolean(editoption1)" @click="changeedit()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-success pull-right">Edit</button>
                            <div v-if="Boolean(editoption2)">
                            <button @click="cancel()" style="width: 93px;height: 30px;font-size: 16px;padding: 2px;" class="btn btn-default pull-right mr-2">Cancel</button>
                            </div>
                        </div>
                        <div class="row mt-2">
                          <div class="row mt-2" v-if="isclient =='yes' || isclient =='Yes'">
                                <div class="col-md-6">
                                <label>Client Name</label>
                                <b-form-input v-model.lazy.trim="$v.form.companyName.$model" type="text" disabled="disabled" />
                                </div>
                                <div class="col-md-6">
                                  <label>Client Email</label>
                                  <b-form-input :disabled="Boolean(editoption)" type="text" v-model.lazy.trim="$v.form.client_emailid.$model" placeholder="Client Email*" />
                                  <p v-if="clientemail_error" class="login-alert-msg error-content">* Enter client email ID</p>
                                  <p v-if="!$v.form.client_emailid.email" class="login-alert-msg error-content">* Enter valid client email ID</p>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <label>Title</label>
                                <b-form-input type="text" v-model.lazy.trim="$v.form.job_title.$model" disabled="disabled" placeholder="Job Title*" />
                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Validity</label>
                                <span class="date select-icon" style="height: 40px;margin-top: 23px;"><i class="uil uil-calender"></i></span>
                                <datetime :disabled="Boolean(editoption)" v-model.lazy.trim="$v.form.post_validity.$model" format="dd-MMM-yyyy" :min-datetime="minDatetime1" value-zone="Asia/Tokyo" zone="Asia/Tokyo" type="date" placeholder="Select Validity *">
                                </datetime>
                                <div v-if="$v.form.post_validity.$error">
                                <p v-if="!$v.form.post_validity.required" class="login-alert-msg error-content">* Select post validity</p>
                                </div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Overall Experience</label>
                                <div class="form-row">
                                <div class="form-group">
                                    <div class="form-select">
                                    <select :disabled="Boolean(editoption)" @change="updateyear()" v-model="form.year_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                                        <option value='' disabled>Select Year *</option>
                                        <option value="1">1 year</option>
                                        <option v-for="x in 19" v-bind:value="x +1" :key="x">{{x + 1}} years</option>
                                    </select>
                                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                    </div>
                                    <div v-if="$v.form.year_of_experience.$error">
                                    <p v-if="!$v.form.year_of_experience.required" class="login-alert-msg error-content">* Select the year</p>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="form-select">
                                    <select :disabled="Boolean(editoption)" id="month" v-model="form.month_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month_of_experience') }">
                                        <option value='' disabled>Select Month *</option>
                                        <option value="0">0 month</option>
                                        <option value="1">1 month</option>
                                        <option v-for="x in 10" v-bind:value="x +1" :key="x">{{x + 1}} months</option>
                                    </select>
                                    <span for="month" class="select-icon"><i class="fa fa-chevron-down"></i></span>
                                    </div>
                                    <div v-if="$v.form.month_of_experience.$error">
                                    <p v-if="!$v.form.month_of_experience.required" class="login-alert-msg error-content">* Select the month</p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-select">
                                <label v-if="!showRole">Primary Skills</label>
                                <label v-if="showRole">Required Technical Skills</label>
                                <multiselect :disabled="Boolean(editoption)" :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.primarySkils" v-bind:class="{ 'is-invalid': !chkState('primarySkils') }" placeholder="Select Skills*" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true" @input="add()"></multiselect>
                                </div>
                            </div>
                            <div class="mb-2 col-md-12 mt-2" v-for="(input,k) in showpskills" :key="k">
                              <div class="form-row">
                                <div class="" style="width: 54%;">
                                    <span :title="input.skill.name" class="over-len newdesign" style="margin-left:20px; width: 100%; font-weight:bold; text-align:left;border-radius: 0px;">{{input.skill.name}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="mb-2 col-md-12 mt-2" v-for="(input,k) in inputs" :key="k">
                              <div class="form-row">
                                <div class="" style="width: 54%;">
                                    <span :title="input.skill_name" class="over-len newdesign" style="margin-left:20px; width: 100%; font-weight:bold; text-align:left;border-radius: 0px;">{{input.skill_name}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <div class="form-select">
                                <label v-if="!Boolean(showRole)">Secondary Skills</label>
                                <label v-if="Boolean(showRole)">Preferred Technical Skills</label>
                                <multiselect :disabled="Boolean(editoption)" :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.secoundarySkills" v-bind:class="{ 'is-invalid': !chkState('secoundarySkills') }" placeholder="Select Skills" label="name" track-by="name" :options="sSkils" :group-select="true" :multiple="true" @input="addsecondaryskill()"></multiselect>
                                </div>
                            </div>
                            <div class="mb-2 col-md-12 mt-2" v-for="(input,k) in showsskills" :key="k">
                              <div class="form-row">
                                <div class="" style="width: 54%;">
                                    <span :title="input.skill.name" class="over-len newdesign" style="margin-left:20px; width: 100%; font-weight:bold; text-align:left;border-radius: 0px;">{{input.skill.name}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="mb-2 col-md-12 mt-2" v-for="(input,k) in secondaryinputs" :key="k">
                              <div class="form-row">
                                <div class="" style="width: 54%;">
                                    <span :title="input.skill_name" class="over-len newdesign" style="margin-left:20px; width: 100%; font-weight:bold; text-align:left;border-radius: 0px;">{{input.skill_name}}</span>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12">

                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Attachment</label>
                                <div class="custom-file-upload" :disabled="Boolean(editoption)">
                                <div v-if="files.length < 1" class="show-doc-empty">Select the File </div>
                                <div class="show-doc" v-if="files.length > 0">
                                    <span :disabled="Boolean(editoption)" class="doc-file pull-left" v-for="x in files.slice(0, 2)" :key="x"><span class="doc-name">{{x.name}} </span><i @click="removeUploading1(x)" v-if="!Boolean(editoption)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                                </div>
                                <label :disabled="Boolean(editoption)" for="filess"><i class="uil uil-upload" aria-hidden="true"></i> Upload </label>
                                <input :disabled="Boolean(editoption)" @change="fileUploadss($event)" style="visibility: hidden;" type="file" id="filess" name="myfiles1[]"/>
                                </div>
                                <p style="color: #aeaaaa;margin: 3px 0 10px;">Supported format (.pdf, .doc, .docx), Size (Max 2MB)</p>
                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Job Description</label>
                                <b-form-textarea :disabled="Boolean(editoption)" @keyup="changedesc()" v-model.lazy.trim="$v.form.org_description.$model" :state="chkState('org_description')" class="textarea" rows="3" placeholder="Enter Job Description"></b-form-textarea>
                                <div>
                                <p class="login-alert-msg error-content mb-1" style="color: #b1abaa !important">{{desclength}} characters left</p>
                                </div>
                                <div v-if="$v.form.org_description.$error">
                                <p v-if="!$v.form.org_description.required" class="login-alert-msg error-content">* Enter the job description</p>
                                <p v-if="!$v.form.org_description.maxLength" class="login-alert-msg error-content">* Job description can be max 2000 characters long</p>
                                </div>
                            </div>
                            <div class="col-md-12 mt-2">
                                <label>Remarks</label>
                                <b-form-textarea :disabled="Boolean(editoption)" @keyup="changeremarks()" v-model.lazy.trim="$v.form.job_comments.$model" :state="chkState('job_comments')" class="textarea" rows="3" placeholder="Enter Remarks"></b-form-textarea>
                                <div>
                                <p class="login-alert-msg error-content mb-1" style="color:#b1abaa !important">{{remarklength}} characters left</p>
                                </div>
                                <div v-if="$v.form.job_comments.$error">
                                <p v-if="!$v.form.job_comments.maxLength" class="login-alert-msg error-content">* Remarks can be max 600 characters long</p>
                                </div>
                            </div>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
// import ProfileModal from '../Feature/profileDetails'
// import ReasonPopup from '../Feature/reasonpopup'
// import AddShedule from '../Feature/addshedule'
// import ScheduleDetails from '../Feature/interestdetail'
// import StarRating from 'vue-star-rating'
import Vue from 'vue'
// import addpost from '../Feature/addpost_dashboard'
import Multiselect from 'vue-multiselect'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import moment from 'moment'
// import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
// import CardView from '../Feature/cardView'

import $ from 'jquery'
Vue.use(moment)
export const EventBus = new Vue()
const formShape = {
  job_title: '',
  year_of_experience: '',
  month_of_experience: '',
  post_validity: '',
  primarySkils: '',
  secoundarySkills: '',
  job_interview_type: 'video',
  org_description: '',
  job_comments: ''
}
const clickHandler = function (userid) {
  // console.log(`Oh, that's nice. It's gotten ${userid} clicks! :)`)
}
// Listen to the event.
EventBus.$on('i-got-clicked', clickHandler)

export default {
  data () {
    return {
      viewid: [],
      pSkils: [],
      sSkils: [],
      inputs: [],
      postdetails: [],
      secondaryinputs: [],
      showsskills: [],
      showpskills: [],
      job_title: '',
      client_emailid: '',
      client_name: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      job_skills: '',
      post_unique_id: '',
      post_expired: false,
      job_validity: '',
      job_postedon: '',
      interestedsend: [],
      interestedsendlength: 0,
      productsShow: 20,
      datas: [],
      files: [],
      releventprofiles: [],
      interested: [],
      interestedlength: 0,
      postdatas: [],
      bothinterest: [],
      bothinterestlength: 0,
      availabledate: [],
      groupeddate: [],
      desclength: 2000,
      remarklength: 600,
      availabletime: [],
      getshedule: [],
      getshedulelength: 0,
      sheduledatas: [],
      reasonList: [],
      selecttimedetais: [],
      startdatetime: '',
      enddatetime: '',
      selectdate: '',
      mainurl: '',
      base_urls: BaseURLV3,
      postsearch: '',
      postsort: 0,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      tabOne: false,
      tabTwo: false,
      tabThree: false,
      tabFour: false,
      tabFive: false,
      tabSix: false,
      posttabOne: true,
      posttabTwo: false,
      posttabThree: false,
      editoption1: true,
      editoption2: false,
      editoption: true,
      posttabFour: false,
      posttabFive: false,
      showfiletersend: true,
      showfileterreceive: false,
      selectpost: '',
      modalOpen: false,
      shwovalue: false,
      sheduledetailsOpen: false,
      reasonOpen: false,
      intestpoput: false,
      intestpoputre: false,
      showconfirm: false,
      validationerror: false,
      validationerrorre: false,
      pvalidation: 0,
      pskillerror: false,
      Sskillerror: false,
      showtime: false,
      isLoading: true,
      fullPage: true,
      businessunitlist: false,
      enableeditpost: false,
      businessunitlength: 0,
      profileid: '',
      actiontype: '',
      form: Object.assign({}, formShape),
      interest_count: 0,
      receive_interest_count: 0,
      send_interest_count: 0,
      showfileterreceivesend: false,
      minDatetime1: '',
      imageupload: 0,
      dirty_form: true,
      showRole: false,
      isclient: 'no',
      quessclient: false,
      otheremailList: [],
      otherEmails: '',
      bull_horn_number: '',
      remarkAlert: '',
      seekindex: '',
      comments: ''
    }
  },
  props: [
    'shwovalueEditPost', 'postId', 'postData'
  ],
  components: {
    multiselect: Multiselect
  },
  created () {
    this.tabOne = true
    this.querytype = this.$route.query.type
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    this.minDatetime1 = year + '-' + month + '-' + day
    // this.$root.$emit('navigate', 'Post')
  },
  mounted () {
    this.config = {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    }
    var data = {
      search: ''
    }
    axios.post(BaseURLV3 + '/org/skills', data, this.config).then(response => {
      this.pSkils = response.data.skills
      this.sSkils = response.data.skills
    }).catch(e => {
    })
    this.getPostdata(this.postId, this.postData)
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      job_title: {
        required
        // minLength: minLength(3)
      },
      year_of_experience: {
        required
      },
      month_of_experience: {
        required
      },
      post_validity: {
        required
      },
      primarySkils: {

      },
      secoundarySkills: {

      },
      job_interview_type: {
        required
      },
      org_description: {
        required
        // maxLength: maxLength(2000)
      },
      job_comments: {
        // maxLength: maxLength(600)
      },
      client_emailid: {
        email
      },
      companyName: {

      }
    }
  },
  methods: {
    closePost (reload = false) {
      var dat = {
        close: false,
        reload: reload
      }
      this.$emit('editpost_emit', dat)
    },
    updateOtherkills () {
      axios.post(BaseURLV3 + '/dashboard/add_others_skill_acs/' + this.selectpost + '/' + this.userInfo._id, {
        formData: this.otheremailList
      }, this.config).then(response => {
      }).catch(e => {
        console.log(e)
      })
    },
    enterEmail () {
      // console.log(this.otherEmails)
      if (this.otherEmails === '') {
        return false
      }
      this.otheremailList.push({
        skill_id: 0,
        skill_name: this.otherEmails,
        year_of_experience: 0,
        month_of_experience: 0
      })
      this.otherEmails = ''
    },
    removeEmail (index) {
      this.otheremailList.splice(index, 1)
      // console.log(this.otheremailList)
    },
    changedesc () {
      const len = this.form.org_description.length
      // console.log(len)
      if (len < 2001) {
        const cal = 2000 - len
        this.desclength = cal
      } else if (len === 2000 || len > 2000) {
        this.desclength = 0
      }
    },
    changeremarks () {
      const len = this.form.job_comments.length
      if (len < 601) {
        const cal = 600 - len
        this.remarklength = cal
      } else if (len === 600 || len > 600) {
        this.remarklength = 0
      }
    },
    changeedit () {
      // console.log('change')
      this.editoption = false
      this.editoption2 = true
      this.editoption1 = false
    },
    cancel () {
      this.editoption = true
      this.editoption2 = false
      this.editoption1 = true
    },
    updateyear () {
      // console.log(this.form.year_of_experience)
      this.topyear = this.form.year_of_experience
    },
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    fileUploadss (e) {
      // console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (e.target.files[k].type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || e.target.files[k].type === 'application/pdf' || e.target.files[k].type === 'application/msword') {
          if (e.target.files[k].size < '2000001') {
            this.imageupload = 1
            this.files = []
            this.files.push(e.target.files[k])
          }
        }
      }
      $('#file').val('')
      // console.log(this.files)
    },
    removeUploading1 (index) {
      if (this.imageupload === 0) {
        this.deleteattachment(this.files[0].id)
      }
      this.files.splice(index, 1)
      // console.log(this.files)
    },
    uploading () {
      // console.log(this.files)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.files.length; k++) {
        formData.append('image', this.files[k])
      }
      if (this.files.length > 0) {
        axios.post(BaseURLV3 + '/dashboard/upload_post_attachment/' + this.post_id,
          formData, config).then(response => {
          // window.location.href = '/Dashboard'
        }, config).catch(e => {
          console.log(e)
        })
      }
    },
    onSubmitProfile () {
      const optionsOverrides = {
        durations: {
          global: 3000
        },
        labels: {
          success: '',
          warning: ''
        },
        position: 'bottom-right',
        icons: {
          prefix: "<i class='uil uil-exclamation-triangle'></i>",
          suffix: '',
          success: '',
          warning: '',
          enabled: true
        }
      }
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      if (this.isclient === 'no' || this.isclient === 'No') {
        this.form.client_emailid = 'check@gmail.com'
      }
      if (this.isclient === 'yes') {
        if (!this.form.client_emailid) {
          this.clientemail_error = true
        } else {
          this.clientemail_error = false
        }
      }

      console.log('inputs ', this.inputs)
      console.log('secondaryinputs ', this.secondaryinputs)
      if (this.inputs.length !== 0) {
        for (var i = 0; i < this.showpskills.length; i++) {
          this.inputs.push({
            skill_id: this.showpskills[i].skill.id,
            skill_name: this.showpskills[i].skill.name
          })
        }
      }
      if (this.secondaryinputs.length !== 0) {
        for (var j = 0; j < this.showsskills.length; j++) {
          this.secondaryinputs.push({
            skill_id: this.showsskills[j].skill.id,
            skill_name: this.showsskills[j].skill.name
          })
        }
      }
      // this.pskillsvalidation()
      console.log('this.form ', this.form)
      if (this.validate()) {
        this.$nextTick(() => {
          if (this.isclient === 'no' || this.isclient === 'No') {
            this.form.client_emailid = ''
          }
          if (this.isclient === 'yes') {
            if (!this.form.client_emailid) {
              return false
            }
          }
          // if (this.pvalidation === 1) {
          //   this.$awn.success('Select skills years and months', optionsOverrides)
          //   return false
          // }
          var startDatetime = moment(this.form.post_validity).utc().format('yyyy-MM-DD')
          var formData = {
            post_validity: startDatetime,
            // template: this.form.job_description_template,
            year_of_experience: this.form.year_of_experience,
            month_of_experience: this.form.month_of_experience,
            primary: this.inputs,
            secondary: this.secondaryinputs,
            job_comments: this.form.org_description,
            remarks: this.form.job_comments,
            user_id: this.userInfo.user_id,
            // max_year_of_experience: this.form.max_year_of_experience,
            // max_month_of_experience: this.form.max_month_of_experience,
            // location: this.form.job_location,
            // min_ctc: this.form.min_salary,
            // max_ctc: this.form.max_salary,
            // no_of_candidate: this.form.job_vacancy
            client_name: this.form.companyName,
            client_email: this.form.client_emailid
          }
          console.log('formData..........', formData)

          axios.put(BaseURLV3 + '/org/' + this.postId + '/post', formData, this.config)
            .then(async response => {
              if (response.data.success) {
                this.$awn.success('ID updated successfully')
              } else {
                this.$awn.success(response.data.msg, optionsOverrides)
              }
              this.editoption = true
              this.editoption2 = false
              this.editoption1 = true
              // this.$awn.success('JD updated successfully')
              this.closePost(true)
            }).catch(e => {
            })
        })
      } else {
        console.log('validation fail................')
      }
    },
    add () {
      this.primexp = this.form.year_of_experience
      this.primmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.primarySkils.length
      const temp = this.inputs.length
      this.tempf = this.inputs
      this.inputs = []
      this.sSkils = this.pSkils
      let k = 0
      for (k = 0; k < this.form.primarySkils.length; k++) {
        // this.sSkils.splice(this.form.primarySkils[k].id, 1)
        let check = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.primarySkils[k].id) {
              this.inputs.push({
                skill_id: this.form.primarySkils[k].id,
                skill_name: this.form.primarySkils[k].name
                // year_of_experience: item.year_of_experience,
                // month_of_experience: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          // var y = 0
          // var m = 0
          for (let o = 0; o < this.tempf.length; o++) {
            // if (this.tempf[o].skill_id === this.form.primarySkils[k].id) {
            //   y = this.tempf[o].year_of_experience
            //   m = this.tempf[o].month_of_experience
            // } else {
            //   y = 0
            //   m = 0
            // }
          }
          this.inputs.push({
            skill_id: this.form.primarySkils[k].id,
            skill_name: this.form.primarySkils[k].name
            // year_of_experience: y,
            // month_of_experience: m
          })
          check = 1
        }
        if (check === 0) {
          // console.log(this.form.primarySkils[k].year_of_experience)
          // if (this.form.primarySkils[k].year_of_experience === undefined) {
          //   y = 0
          // } else {
          //   y = this.form.primarySkils[k].year_of_experience
          // }
          // if (this.form.primarySkils[k].month_of_experience === undefined) {
          //   m = 0
          // } else {
          //   m = this.form.primarySkils[k].month_of_experience
          // }
          this.inputs.push({
            skill_id: this.form.primarySkils[k].id,
            skill_name: this.form.primarySkils[k].name
            // year_of_experience: y,
            // month_of_experience: m
          })
        }
        // console.log(check)
      }
    },
    addsecondaryskill () {
      // ssdds
      this.secondexp = this.form.year_of_experience
      this.secondmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.secoundarySkills.length
      const temp = this.secondaryinputs.length
      this.tempf = this.secondaryinputs
      this.secondaryinputs = []
      let k = 0
      for (k = 0; k < this.form.secoundarySkills.length; k++) {
        let check = 0
        // var y = 0
        // var m = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.secoundarySkills[k].id) {
              this.secondaryinputs.push({
                skill_id: this.form.secoundarySkills[k].id,
                skill_name: this.form.secoundarySkills[k].name
                // year_of_experience: item.year_of_experience,
                // month_of_experience: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          for (let o = 0; o < this.tempf.length; o++) {
            // if (this.tempf[o].skill_id === this.form.secoundarySkills[k].id) {
            //   y = this.tempf[o].year_of_experience
            //   m = this.tempf[o].month_of_experience
            // }
          }
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name
            // year_of_experience: y,
            // month_of_experience: m
          })
          check = 1
        }
        if (check === 0) {
          // if (this.form.secoundarySkills[k].year_of_experience === undefined) {
          //   y = 0
          // } else {
          //   y = this.form.secoundarySkills[k].year_of_experience
          // }
          // if (this.form.secoundarySkills[k].month_of_experience === undefined) {
          //   m = 0
          // } else {
          //   m = this.form.secoundarySkills[k].month_of_experience
          // }
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name
            // year_of_experience: y,
            // month_of_experience: m
          })
        }
      }
    },
    findFirstError (component = this) {
      console.log('component ', component)
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      console.log('this.$v ', this.$v)
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    updatePrimaryskills () {
      for (let i = 0; i < this.showpskills.length; i++) {
        this.inputs.push({
          skill_id: this.showpskills[i].id,
          skill_name: this.showpskills[i].name,
          year_of_experience: this.showpskills[i].year_of_experience,
          month_of_experience: this.showpskills[i].month_of_experience
        })
      }
      axios.post(BaseURLV3 + '/dashboard/add_primary_skill/' + this.post_id + '/' + this.userInfo._id, {
        formData: this.inputs
      }, this.config).then(response => {
        // window.location.href = '/Dashboard'
      }).catch(e => {
        console.log(e)
      })
    },
    updateSecondarykills () {
      for (let k = 0; k < this.showsskills.length; k++) {
        this.secondaryinputs.push({
          skill_id: this.showsskills[k].id,
          skill_name: this.showsskills[k].name,
          year_of_experience: this.showsskills[k].year_of_experience,
          month_of_experience: this.showsskills[k].month_of_experience
        })
      }
      axios.post(BaseURLV3 + '/dashboard/add_secondary_skill_edit/' + this.post_id + '/' + this.userInfo._id, {
        formData: this.secondaryinputs
      }, this.config).then(response => {
        this.getpdetails(this.selectpost)
      }).catch(e => {
        console.log(e)
      })
    },
    deleteattachment (id) {
      axios.get(BaseURLV3 + '/dashboard/delete_post_attachment/' + id, this.config).then(response => {
      }).catch(e => {
        console.log(e)
      })
    },
    removeerrorp () {
      this.pskillerror = false
    },
    removeerror_other () {
      this.pskillerror = false
    },
    removeerrors () {
      this.Sskillerror = false
    },
    getPostdata (pid, post) {
      this.getpdetails(pid)
      this.editoption1 = true
      this.editoption2 = false
      this.editoption = true
      this.inputs = []
      if (post !== 'no' && post) {
        post.primarySkillName = ''
        for (var j = 0; j < post.p_p_skill.length; j++) {
          if (post.primarySkillName === '') {
            post.primarySkillName = post.p_p_skill[j].skill.name
          } else {
            post.primarySkillName = post.primarySkillName + ', ' + post.p_p_skill[j].skill.name
          }
        }
        this.job_title = post.job_title
        this.post_unique_id = post.unique_id
        // this.post_expired = post.post_validity
        this.job_skills = post.primarySkillName
        this.job_validity = post.post_validity
        this.job_postedon = post.created_on
        this.selectpost = pid
        // this.interest_count = post.total_interest_count
        // this.receive_interest_count = post.receive_interest_count
        // this.send_interest_count = post.send_interest_count
        this.client_name = post.client_name
        this.client_emailid = post.client_email
        // this.form.businessunit_id = post.businessunit_id
        // this.bull_horn_number = post.bull_horn_number
      }
    },
    getpdetails (pid) {
      const mainurl = '/org/post/' + pid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        if (response.data.success) {
          this.postdetails = response.data.post
          this.inputs = []
          this.secondaryinputs = []
          this.form.primarySkils = []
          this.form.secoundarySkills = []
          this.form.job_title = this.postdetails.job_title
          this.form.post_validity = this.postdetails.post_validity
          this.form.client_emailid = this.postdetails.client_email
          this.form.companyName = this.postdetails.client_name
          if (this.postdetails.client_name !== null && this.postdetails.client_name !== '' && this.postdetails.client_name !== undefined) {
            this.isclient = 'yes'
          }
          // this.form.dept_name = this.postdetails.dept_name
          // this.isclient = this.postdetails.isclient
          // this.form.businessunit_id = this.postdetails.businessunit_id
          // $('.vdatetime-input').val(moment.utc(this.postdetails.post_validity).format('DD-MMM-YYYY'))
          this.topyear = this.postdetails.year_of_experience
          this.form.year_of_experience = this.postdetails.year_of_experience
          this.form.month_of_experience = this.postdetails.month_of_experience
          // this.form.max_year_of_experience = this.postdetails.max_year_of_experience
          // this.form.max_month_of_experience = this.postdetails.max_month_of_experience
          this.form.job_comments = this.postdetails.remarks
          this.form.org_description = this.postdetails.job_comments
          // this.form.job_vacancy = this.postdetails.no_of_candidate
          // this.form.job_location = this.postdetails.location
          // this.form.max_salary = this.postdetails.max_ctc
          // this.form.min_salary = this.postdetails.min_ctc
          this.showpskills = []
          this.showsskills = []
          this.showpskills = this.postdetails.p_p_skill
          this.showsskills = this.postdetails.p_s_skill
          // this.add()
          // this.addsecondaryskill()
          if (this.postdetails.interview_type === 'Video' || this.postdetails.interview_type === 'video') {
            this.form.job_interview_type = 'video'
          } else {
            this.form.job_interview_type = 'audio'
          }
          if (this.postdetails.attachment != null) {
            // var blob = new Blob()
            // var jdFile = new File([response.data.attachment], 'image.png', { type: blob.type })
            this.files = []
            this.files.push({ name: 'attachement.pdf' })
          }
          this.changeremarks()
          this.changedesc()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>
